import { useState, useEffect } from "react";
import { Menu, X, Heart } from "lucide-react";

const links = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Programs", id: "programs" },
  { label: "Gallery", id: "gallery" },
  { label: "Contact", id: "contact" },
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    scrollTo(id);
    setOpen(false);
  };

  return (
    <header
      data-testid="main-header"
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-white/85 border-b border-slate-100 shadow-sm" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 md:px-10 h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => go("home")}
          className="flex items-center gap-2 group"
        >
          <span className="flex items-center justify-center w-10 h-10 rounded-2xl bg-sky-400 text-white shadow-[0_4px_14px_0_rgba(56,189,248,0.39)] group-hover:rotate-6 transition-transform">
            <Heart className="w-5 h-5 fill-white" />
          </span>
          <span className="font-extrabold text-lg leading-tight text-slate-900 text-left">
            Blessed Beginnings
            <span className="block text-[11px] font-semibold tracking-wide text-sky-500 -mt-0.5">
              Learning Center
            </span>
          </span>
        </button>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}-link`}
              onClick={() => go(l.id)}
              className="text-slate-700 font-semibold hover:text-sky-500 transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-schedule-tour-button"
            onClick={() => go("contact")}
            className="bg-amber-400 hover:bg-amber-500 text-amber-950 font-bold py-2.5 px-6 rounded-full shadow-[0_4px_14px_0_rgba(251,191,36,0.39)] hover:-translate-y-0.5 transition-all duration-200"
          >
            Schedule a Tour
          </button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 text-slate-800"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-white border-t border-slate-100 px-5 py-4 flex flex-col gap-3 shadow-lg">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-${l.id}-link`}
              onClick={() => go(l.id)}
              className="text-left text-slate-700 font-semibold py-2 hover:text-sky-500"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="mobile-schedule-tour-button"
            onClick={() => go("contact")}
            className="bg-amber-400 text-amber-950 font-bold py-3 rounded-full mt-1"
          >
            Schedule a Tour
          </button>
        </div>
      )}
    </header>
  );
}
